require("./details.scss");

class Details {
    init = () => {
        window.addEventListener("scroll", this.doSticky);
        this.goToAnchor();
        this.initDropDowns();
    }

    doSticky = () => { //haha what a method name
        let topOffset = 300;
        let topOffsetForGallery = 170;
        let triggerElement = document.querySelector('[data-role="details-sticky-trigger"]');
        let sticky = document.querySelector('[data-role="details-sticky"]');
        let bounds = triggerElement.getBoundingClientRect();
        let visualComparison = document.querySelector('[data-role="visual-comparison"]');
        if (visualComparison) { //Sometimes visual comparison is not available
            let boundsVC = visualComparison.getBoundingClientRect();
            sticky.classList.toggle('overVC', boundsVC.top < topOffsetForGallery && boundsVC.bottom > topOffsetForGallery);
        }
        sticky.classList.toggle('sticky', bounds.top < topOffset);
        triggerElement.classList.toggle('sticky', bounds.top < topOffset);
    }

    collapseAllAutoComplete = (id) => {
        document.querySelectorAll('[data-role="autocomplete-dropdown"]:not([id*="' + id + '"])').forEach(x => x.classList.remove('in'));
    };

    initDropDowns() {
        document.querySelectorAll('[data-role="autocomplete-dropdown"]').forEach(x => {
            x.querySelector('[data-role="autocomplete-dropdown-txt"]').addEventListener('click', event => {
                event.stopPropagation(); //this is needed so the dropdown ul opens
                x.querySelector('ul').classList.toggle('d-none');
            });
        });

        document.addEventListener('click', event => {
            document.querySelectorAll('[data-role="autocomplete-dropdown"] ul').forEach(x => x.classList.add('d-none'));
        });
    }

    goToAnchor() {
        if (location.href.endsWith("#details"))
            document.getElementById("details").scrollIntoView();
    }
}
const details = new Details();

window.addEventListener("load", details.init); 